const initialState = {
  data: null,
};

export const sellerPerformance = (state = initialState, action) => {
  switch (action.type) {
    case "GET_SELLER_PERFORMANCE":
      return { data: action.payload };
    default:
      return state;
  }
};
